import { render } from "./homeContent.vue?vue&type=template&id=5aff896f&scoped=true"
import script from "./homeContent.vue?vue&type=script&lang=js"
export * from "./homeContent.vue?vue&type=script&lang=js"

import "./homeContent.vue?vue&type=style&index=0&id=5aff896f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aff896f"]])

export default __exports__